/**
 * @generated SignedSource<<b619eb6678cadc52634a10ae0093f175>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageHeader_siteInfo$data = {
  readonly fundsListUrl: string;
  readonly navigation: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SimpleLink_simpleLink">;
  }>;
  readonly rootUrl: string;
  readonly searchPageUrl: string | null | undefined;
  readonly " $fragmentType": "PageHeader_siteInfo";
};
export type PageHeader_siteInfo$key = {
  readonly " $data"?: PageHeader_siteInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageHeader_siteInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageHeader_siteInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fundsListUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rootUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SimpleLink",
      "kind": "LinkedField",
      "name": "navigation",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SimpleLink_simpleLink"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchPageUrl",
      "storageKey": null
    }
  ],
  "type": "SiteInfo",
  "abstractKey": null
};

(node as any).hash = "e3138d94aa4ecf5ad577389167f2a6fb";

export default node;
